import CalendarProcessingOptionState from './schema/CalendarProcessingOptionsState';
import { createStore } from 'satcheljs';
import '../mutators/initializeCalendarProcessingOptionsMutator';
import '../mutators/updateCalendarProcessingOptionsMutator';

let initialStore: CalendarProcessingOptionState = {
    calendarProcessingOptions: null,
};

export default createStore<CalendarProcessingOptionState>(
    'calendarProcessingOptions',
    initialStore
);
